import { render, staticRenderFns } from "./ShoppingCartActionButtons.vue?vue&type=template&id=6204f810&scoped=true&"
import script from "./ShoppingCartActionButtons.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartActionButtons.vue?vue&type=style&index=0&id=6204f810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204f810",
  null
  
)

export default component.exports